





























































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, Classification } from "../../modules/teacher/ClassificationList"
import { downloadMasterExcel } from "../../modules/teacher/MasterExcelDownload"

export interface Data {
  tabNo: number
  condition: SearchCondition
  classifications: Classification[]
  fields: any[]
  perPage: number
  totalCount: number
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  isDownloading: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 3,
      condition: new SearchCondition(),
      classifications: new Array<Classification>(),
      fields: [
        {key: "class_code", label: "クラスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "クラス名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center', thStyle: {width: "80px"}},
      ],
      perPage: 100,
      totalCount: 0,
      isShowPagination: false,
      isAllDeleteChecked: false,
      isDownloading: false,
      errors: [],
    });

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };
    
    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {
      if(state.isDownloading){
        return;
      }

      state.isDownloading = true;
      try {
        await downloadMasterExcel(context, {
          apiPath: "classification_list",
          condition: state.condition,
          fileName: "クラスマスタ.xlsx",
          confirmMessage: "検索条件に一致するクラスマスタをダウンロードします。よろしいですか？",
          columns: ["class_code", "name"],
          deleteColumnCount: 3,
        });
      }
      finally {
        state.isDownloading = false;
      }
    }

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.classifications.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.classifications.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/classification_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = []
      await http.get(`/api/teacher/classification_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.classifications = response.data.classifications.map((x: any) => new Classification(x)); 
        state.totalCount = state.classifications.length == 0 ? 0 : state.classifications[0].full_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      allSelectChanged,
      deleteMst,
      searchButtonClick,
      changePage,
      download,
    };
  }
});
